import { render, staticRenderFns } from "./SpreadsheetThumbPreview.vue?vue&type=template&id=61007c73&scoped=true"
import script from "./SpreadsheetThumbPreview.vue?vue&type=script&lang=js"
export * from "./SpreadsheetThumbPreview.vue?vue&type=script&lang=js"
import style0 from "./SpreadsheetThumbPreview.vue?vue&type=style&index=0&id=61007c73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61007c73",
  null
  
)

export default component.exports